import { useRef, useEffect } from 'react';

export const useAutoFocus = <T extends HTMLElement>() => {
  const ref = useRef<T>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      ref.current?.focus();
    }, 50);
    return () => clearTimeout(timer);
  }, []);

  return ref;
};